import { EncryptedVersionMessages, MessageToTTOnline } from 'utils/types/communication';

// TODO, instead of asterisk check valid targets
export function sendMessage(message: MessageToTTOnline | EncryptedVersionMessages) {
  window.parent.postMessage(message, '*');
}

export function sendAppCompleted(metadata?: string, chatQueueId?: number) {
  if (window.terveystaloApp) {
    const { sendMessage } = window.terveystaloApp;
    sendMessage({ type: 'Close', navigation: 'ChatQueue', metadata, chatQueueId });
  }
}
export function sendAppError(error: string) {
  if (window.terveystaloApp) {
    const { sendMessage } = window.terveystaloApp;
    sendMessage({ type: 'Error', error });
  }
}
